module.exports = __webpack_public_path__ + "img/faculty-diane-cropped.5ca4e5ca.jpg";